import MapObject from 'map/MapObject';

export default class MapController {
  static handleMapCenter() {
    MapObject.setDefaultMapExtentForSite();
  }
}
